<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="公司简介" name="first"></el-tab-pane>
      <el-tab-pane label="企业文化" name="second"></el-tab-pane>
      <el-tab-pane label="公司资质" name="third"></el-tab-pane>
    </el-tabs>
    <div class="container">
      <p v-show="activeName == 'first'">
        &nbsp; &nbsp;&nbsp;&nbsp; 深圳东迈智能机电有限公司是由成都东迈电子科技有限责任公司（中文简称东迈电科，英文简称DMETC）投资成立的一家高科技公司，
        其母公司成都东迈电子科技有限责任公司成立于2006年，公司主要技术人员已经有近20年自动化领域的行业经验，并是国内最早从事快递分拣设备研发的企业之一。
        东迈电科在广东深圳、江苏南京、四川成都等地设立有直营公司，在新疆、西藏、重庆、湖北、贵州、云南、陕西、甘肃等地设有办事机构。
        深圳东迈智能机电有限公司是一家从事智能物流分拣设备研发、生产和销售的高科技企业。公司致力于快递自动化分拣设备的研发、应用及营运，
        为客户量身定制快递自动分拣解决方案，以减少快递分拣行业对传统劳动力的依赖，并以提升时效和客户体验为奋斗目标。
        公司始终将科技创新和人才培养作为公司的发展目标，拥有一批优秀的物流及分拣领域专家，同时与国内多所知名院校开展产研合作，
        成功将机器视觉、人工智能等前沿技术融入快递分拣系统，为快递物流行业的自动化分拣作出了重要贡献。
      </p>
      <div v-show="activeName == 'second'">
        <h3>公司价值观：</h3>
        <p>互惠互利&nbsp;&nbsp; 共同成长&nbsp;&nbsp; 持续发展&nbsp;&nbsp; 共创未来</p>
        <h3>公司精神：</h3>
        <p>忠诚守信&nbsp;&nbsp; 创新奋进&nbsp;&nbsp; 不断超越&nbsp;&nbsp; 追求卓越</p>
        <h3>公司理念：</h3>
        <p>&nbsp;&nbsp;&nbsp;&nbsp; 以专业、精炼的品质，提供优秀的物流分拣及水果分拣解决方案，为客户创造价值；以职业、事业为支撑，为员工搭建广阔发展舞台，实现员工愿望和梦想。</p>
        <h3>公司愿景：</h3>
        <p>&nbsp;&nbsp;&nbsp;&nbsp; 成为行业一流的智能分拣方案供应商。</p>
      </div>
      <div v-show="activeName == 'third'">
        <div>
          <h3>营业执照 :</h3>
          <img src="@/assets/img/businessLicense.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyPage",
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {}
};
</script>

<style  scoped>
.slide img {
  width: 100%;
  height: 500px;
}
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  text-align: center;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__item {
  font-size: 20px;
  width: 200px;
}
.container p {
  width: 70%;
  margin: auto;
  text-align: left;
  font-size: 18px;
  line-height: 40px;
}
.container h3 {
  text-align: left;
  width: 70%;
  margin: auto;
  padding: 20px;
}
::v-deep .el-tabs__nav-scroll {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>